import { render, staticRenderFns } from "./RegraFuro.vue?vue&type=template&id=a02a00be&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./RegraFuro.vue?vue&type=script&lang=js&"
export * from "./RegraFuro.vue?vue&type=script&lang=js&"
import style0 from "./RegraFuro.vue?vue&type=style&index=0&id=a02a00be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a00be",
  null
  
)

export default component.exports